import React from 'react';
import ToastContent from './ToastContent';
import { toast } from 'react-toastify';

// FUNC
const showNotification = (type, message) => {
  if (type === 'info') {
    toast.info(<ToastContent type={type} message={message} />);
  } else if (type === 'warning') {
    toast.warning(<ToastContent type={type} message={message} />);
  } else if (type === 'error') {
    toast.error(<ToastContent type={type} message={message} />);
  } else if (type === 'success') {
    toast.success(<ToastContent type={type} message={message} />);
  } else {
    toast.info(<ToastContent type={type} message={message} />);
  }
};

export { showNotification as default };
